import React, { useState, FormEvent, useEffect } from "react";
import Button from "../form-components/input/Button";
import { useLocation } from 'react-router-dom';

const applicationType = 'RULING';

const Ruling = () => {
    const [suitNo, setSuitNo] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const location = useLocation();
    const suitNumber = location.state?.id;
    const authToken = sessionStorage.getItem('token');

    useEffect(() => {
        if (suitNumber) {
            setSuitNo(suitNumber);
        }
    }, [suitNumber]);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
    
        if (!authToken) {
            setErrorMessage("Authentication token is missing. Please log in.");
            return;
        }
    
        // Check caseId and applicationType
        if (!suitNo) {
            setErrorMessage("Suit Number is required.");
            return;
        }
        if (!applicationType) {
            setErrorMessage("Application type is required.");
            return;
        }
    
        setIsLoading(true);
        setErrorMessage(null);
        console.log("caseId:", suitNo);
        console.log("applicationType:", applicationType);
    
        try {
            const response = await fetch('https://backend-kyw8.onrender.com/court-records/payment/link', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ suitNo, applicationType }),
            });
    
            const result = await response.json();
    
            if (!response.ok) {
                throw new Error(result.error || `HTTP error! Status: ${response.status}`);
            }
    
            const paymentLink = result?.data?.data?.link;
            if (paymentLink) {
                console.log('Payment Link:', paymentLink);
                setTimeout(() => {
                    window.location.href = paymentLink;
                }, 2000);
            } else {
                throw new Error('Payment link not found in the response.');
            }
        } catch (error: any) {
            console.error('Error initiating payment:', error);
            setErrorMessage(error.message || 'An error occurred while initiating payment.');
        } finally {
            setIsLoading(false);
        }
    };
    
    return (
        <div className="">
            <div className="form-div !max-w-3/4 flex flex-col gap-6 border border-[#222222] rounded-[20px]">
                <h3 className="form-header">Apply for Ruling</h3>
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col">
                        <label htmlFor="suitNumber">Suit No:</label>
                        <input
                            type="text"
                            id="suitNumber"
                            placeholder="XX/YYY/XX/YYYY"
                            value={suitNo}
                            className="vc-reg-input"
                            onChange={(e) => setSuitNo(e.target.value)}
                        />
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    <div className="flex justify-end col-span-full">
                        <Button 
                            buttonText="Submit" 
                            isLoading={isLoading} 
                            disabled={isLoading}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Ruling;
